import { ApiError } from "@altek/ui/lib/problem";

/**
 * «DESTEK KODU» YALNIZ SUNUCUNUN KENDİ ARIZASINDA (5xx) — 9 Ekim 2026, 3. tur.
 *
 * Kitin sözleşmesi bu: `ApiError.requestId` «kişiye yalnız 5xx'te gösterilir»
 * (`@altek/ui/lib/problem`). Yönetim formları her hatada `requestId` veriyordu; «Bu kod zaten
 * kayıtlı» gibi kişinin kendisinin düzelteceği bir 409'un altında «Destek kodu: …» yazınca
 * kişi bunu destek ekibine iletilecek bir arıza sanıyordu. 4xx'te cümle yeter; kod yok.
 */
export function supportCodeOf(error: unknown): string | null {
  return error instanceof ApiError && error.status >= 500 ? error.requestId : null;
}

/** Kayıtlı bir değer (409 `DUPLICATE_KEY`) mi? Formlar bunu alanın altına yazar. */
export function isDuplicate(error: unknown): boolean {
  return error instanceof ApiError && error.code === "DUPLICATE_KEY";
}

/** Alanı bilinmeyen bir «zaten kayıtlı» için şeridin cümlesi — hangi alanın sorun olduğunu söyler. */
export const DUPLICATE_SENTENCE =
  "Bu bilgilerle bir kayıt zaten var. Kod gibi benzersiz olması gereken alanı değiştirip yeniden deneyin.";
